/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SelectField,
  TextField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createBankTransfer } from "../graphql/mutations";
const client = generateClient();
export default function BankTransferCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    amount: "",
    accountHolderName: "",
    accountNumber: "",
    bankName: "",
    type: "",
    receiptUrl: "",
    reference: "",
    paymentStatus: "",
  };
  const [amount, setAmount] = React.useState(initialValues.amount);
  const [accountHolderName, setAccountHolderName] = React.useState(
    initialValues.accountHolderName
  );
  const [accountNumber, setAccountNumber] = React.useState(
    initialValues.accountNumber
  );
  const [bankName, setBankName] = React.useState(initialValues.bankName);
  const [type, setType] = React.useState(initialValues.type);
  const [receiptUrl, setReceiptUrl] = React.useState(initialValues.receiptUrl);
  const [reference, setReference] = React.useState(initialValues.reference);
  const [paymentStatus, setPaymentStatus] = React.useState(
    initialValues.paymentStatus
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setAmount(initialValues.amount);
    setAccountHolderName(initialValues.accountHolderName);
    setAccountNumber(initialValues.accountNumber);
    setBankName(initialValues.bankName);
    setType(initialValues.type);
    setReceiptUrl(initialValues.receiptUrl);
    setReference(initialValues.reference);
    setPaymentStatus(initialValues.paymentStatus);
    setErrors({});
  };
  const validations = {
    amount: [{ type: "Required" }],
    accountHolderName: [{ type: "Required" }],
    accountNumber: [{ type: "Required" }],
    bankName: [{ type: "Required" }],
    type: [],
    receiptUrl: [],
    reference: [],
    paymentStatus: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          amount,
          accountHolderName,
          accountNumber,
          bankName,
          type,
          receiptUrl,
          reference,
          paymentStatus,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createBankTransfer.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "BankTransferCreateForm")}
      {...rest}
    >
      <TextField
        label="Amount"
        isRequired={true}
        isReadOnly={false}
        type="number"
        step="any"
        value={amount}
        onChange={(e) => {
          let value = isNaN(parseFloat(e.target.value))
            ? e.target.value
            : parseFloat(e.target.value);
          if (onChange) {
            const modelFields = {
              amount: value,
              accountHolderName,
              accountNumber,
              bankName,
              type,
              receiptUrl,
              reference,
              paymentStatus,
            };
            const result = onChange(modelFields);
            value = result?.amount ?? value;
          }
          if (errors.amount?.hasError) {
            runValidationTasks("amount", value);
          }
          setAmount(value);
        }}
        onBlur={() => runValidationTasks("amount", amount)}
        errorMessage={errors.amount?.errorMessage}
        hasError={errors.amount?.hasError}
        {...getOverrideProps(overrides, "amount")}
      ></TextField>
      <TextField
        label="Account holder name"
        isRequired={true}
        isReadOnly={false}
        value={accountHolderName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              amount,
              accountHolderName: value,
              accountNumber,
              bankName,
              type,
              receiptUrl,
              reference,
              paymentStatus,
            };
            const result = onChange(modelFields);
            value = result?.accountHolderName ?? value;
          }
          if (errors.accountHolderName?.hasError) {
            runValidationTasks("accountHolderName", value);
          }
          setAccountHolderName(value);
        }}
        onBlur={() =>
          runValidationTasks("accountHolderName", accountHolderName)
        }
        errorMessage={errors.accountHolderName?.errorMessage}
        hasError={errors.accountHolderName?.hasError}
        {...getOverrideProps(overrides, "accountHolderName")}
      ></TextField>
      <TextField
        label="Account number"
        isRequired={true}
        isReadOnly={false}
        value={accountNumber}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              amount,
              accountHolderName,
              accountNumber: value,
              bankName,
              type,
              receiptUrl,
              reference,
              paymentStatus,
            };
            const result = onChange(modelFields);
            value = result?.accountNumber ?? value;
          }
          if (errors.accountNumber?.hasError) {
            runValidationTasks("accountNumber", value);
          }
          setAccountNumber(value);
        }}
        onBlur={() => runValidationTasks("accountNumber", accountNumber)}
        errorMessage={errors.accountNumber?.errorMessage}
        hasError={errors.accountNumber?.hasError}
        {...getOverrideProps(overrides, "accountNumber")}
      ></TextField>
      <TextField
        label="Bank name"
        isRequired={true}
        isReadOnly={false}
        value={bankName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              amount,
              accountHolderName,
              accountNumber,
              bankName: value,
              type,
              receiptUrl,
              reference,
              paymentStatus,
            };
            const result = onChange(modelFields);
            value = result?.bankName ?? value;
          }
          if (errors.bankName?.hasError) {
            runValidationTasks("bankName", value);
          }
          setBankName(value);
        }}
        onBlur={() => runValidationTasks("bankName", bankName)}
        errorMessage={errors.bankName?.errorMessage}
        hasError={errors.bankName?.hasError}
        {...getOverrideProps(overrides, "bankName")}
      ></TextField>
      <TextField
        label="Type"
        isRequired={false}
        isReadOnly={false}
        value={type}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              amount,
              accountHolderName,
              accountNumber,
              bankName,
              type: value,
              receiptUrl,
              reference,
              paymentStatus,
            };
            const result = onChange(modelFields);
            value = result?.type ?? value;
          }
          if (errors.type?.hasError) {
            runValidationTasks("type", value);
          }
          setType(value);
        }}
        onBlur={() => runValidationTasks("type", type)}
        errorMessage={errors.type?.errorMessage}
        hasError={errors.type?.hasError}
        {...getOverrideProps(overrides, "type")}
      ></TextField>
      <TextField
        label="Receipt url"
        isRequired={false}
        isReadOnly={false}
        value={receiptUrl}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              amount,
              accountHolderName,
              accountNumber,
              bankName,
              type,
              receiptUrl: value,
              reference,
              paymentStatus,
            };
            const result = onChange(modelFields);
            value = result?.receiptUrl ?? value;
          }
          if (errors.receiptUrl?.hasError) {
            runValidationTasks("receiptUrl", value);
          }
          setReceiptUrl(value);
        }}
        onBlur={() => runValidationTasks("receiptUrl", receiptUrl)}
        errorMessage={errors.receiptUrl?.errorMessage}
        hasError={errors.receiptUrl?.hasError}
        {...getOverrideProps(overrides, "receiptUrl")}
      ></TextField>
      <TextField
        label="Reference"
        isRequired={false}
        isReadOnly={false}
        value={reference}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              amount,
              accountHolderName,
              accountNumber,
              bankName,
              type,
              receiptUrl,
              reference: value,
              paymentStatus,
            };
            const result = onChange(modelFields);
            value = result?.reference ?? value;
          }
          if (errors.reference?.hasError) {
            runValidationTasks("reference", value);
          }
          setReference(value);
        }}
        onBlur={() => runValidationTasks("reference", reference)}
        errorMessage={errors.reference?.errorMessage}
        hasError={errors.reference?.hasError}
        {...getOverrideProps(overrides, "reference")}
      ></TextField>
      <SelectField
        label="Payment status"
        placeholder="Please select an option"
        isDisabled={false}
        value={paymentStatus}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              amount,
              accountHolderName,
              accountNumber,
              bankName,
              type,
              receiptUrl,
              reference,
              paymentStatus: value,
            };
            const result = onChange(modelFields);
            value = result?.paymentStatus ?? value;
          }
          if (errors.paymentStatus?.hasError) {
            runValidationTasks("paymentStatus", value);
          }
          setPaymentStatus(value);
        }}
        onBlur={() => runValidationTasks("paymentStatus", paymentStatus)}
        errorMessage={errors.paymentStatus?.errorMessage}
        hasError={errors.paymentStatus?.hasError}
        {...getOverrideProps(overrides, "paymentStatus")}
      >
        <option
          children="Pending"
          value="Pending"
          {...getOverrideProps(overrides, "paymentStatusoption0")}
        ></option>
        <option
          children="Approved"
          value="Approved"
          {...getOverrideProps(overrides, "paymentStatusoption1")}
        ></option>
        <option
          children="Declined"
          value="Declined"
          {...getOverrideProps(overrides, "paymentStatusoption2")}
        ></option>
      </SelectField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
